import React from 'react';
import { useTranslation } from 'react-i18next';
import Sidebar from '../components/layout/Sidebar';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <>
    <Sidebar />
    <div style={{ marginLeft: '80px' }}>
      <div className="container mt-5">
        <h1>{t('contact.title')}</h1>
        <p>{t('contact.description')}</p>

        <div className="mt-5">
          <h2>{t('contact.whereWeAre')}</h2>
          <p className="mb-3">{t('contact.address')}</p>
          <div className="mb-5" style={{ width: '100%', height: '400px' }}>
            <iframe
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5737.787035449752!2d14.232921!3d40.844804!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133b08f9df67ad61%3A0xa648dbd2733f82df!2sVia%20Raffaele%20Morghen%2C%20181%2C%20Napoli%2C%20NA!5e1!3m2!1sit!2sit!4v1751471627103!5m2!1sit!2sit"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Contact; 